import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui/styles/index';

export const AgreeModal = styled.div`
  overflow-y: auto;
  height: 100%;
  border-radius: ${mixin.pxToVw('20 20 0 0')};
  position: relative;
  z-index: 0;
  .agree_ctns {
    padding: ${mixin.pxToVw('0 20 40 20')};
    font-family: ${({ theme }) => theme.fontFamily.medium};
    table {
      margin: ${mixin.pxToVw('10 0 20 0')};
      border-top: 1px solid #000;
      font-size: ${mixin.pxToVw('14')};
      th {
        font-weight: 500;
        height: ${mixin.pxToVw('35')};
        line-height: ${mixin.pxToVw('35')};
        border-bottom: 1px solid #e5e5e5;
        text-align: center;
      }
      th:nth-child(1) {
        width: 20%;
      }
      th:nth-child(2) {
        width: 30%;
      }
      td {
        padding: ${mixin.pxToVw('15 5 15 5')};
        word-break: keep-all;
        overflow-wrap: break-word;
        position: relative;
        line-height: ${mixin.pxToVw('16.8')};
        vertical-align: middle;
        text-align: center;
        z-index: 1;
        &:before {
          content: '';
          position: absolute;
          display: inline-block;
          border-left: 1px solid #e5e5e5;
          left: 0;
          top: 0;
          bottom: 0;
          z-index: 2;
        }
        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 100%;
          border-bottom: 1px solid #000;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 3;
        }
      }
      td:first-child {
        border-left-width: 0;
        text-align: center;
        &:before {
          display: none;
        }
      }
    }
    .unorder-list {
      li {
        margin-top: ${mixin.pxToVw('8')};
        font-size: ${mixin.pxToVw('12')};
        line-height: ${mixin.pxToVw('17.4')};
        position: relative;
        padding: ${mixin.pxToVw('0 0 0 9')};
        color: #777;
        word-break: keep-all;
        overflow-wrap: break-word;
        &:first-child {
          margin-top: 0;
          font-weight: 700;
          font-family: ${({ theme }) => theme.fontFamily.bold};
          text-decoration: underline;
          font-size: ${mixin.pxToVw('16')};
          line-height: ${mixin.pxToVw('23.2')};
        }
        &:before {
          content: '';
          display: inline-block;
          width: 3px;
          height: 3px;
          background: #777;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: ${mixin.pxToVw('7')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.sm} {
    border-radius: 20px 20px 0 0;
    .agree_ctns {
      padding: 0 20px 40px 20px;
      table {
        margin: 10px 0 20px 0;
        font-size: 14px;
        th {
          height: 35px;
          line-height: 35px;
        }
        td {
          padding: 15px 5px;
          line-height: 16.8px;
        }
      }
      .unorder-list {
        li {
          margin-top: 8px;
          font-size: 12px;
          line-height: 17.4px;
          padding-left: 9px;
          &:first-child {
            font-size: 16px;
            line-height: 24px;
          }
          &:before {
            top: 7px;
          }
        }
      }
    }

    .area-btn {
      //padding-bottom: 30px;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }

    &.is-old-app-iphonex {
      .area-btn {
        padding-bottom: 30px;
      }
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    width: 850px;
    border-radius: 0;
    padding: 40px 40px 50px;
    border: 1px solid #000;
    background: #fff;

    .agree_ctns {
      padding: 0;

      table {
        width: 100%;
        font-size: 14px;
        margin: 0 0 16px 0;
        border: none;

        th {
          height: 58px;
          line-height: normal;
          border-color: #000;

          &:first-child {
            width: 100px;
          }

          &:nth-child(2),
          &:last-child {
            width: calc(50% - 100px);
          }
        }

        td {
          height: 76px;
          line-height: 17px;
          padding: 0 20px;
          color: #333;

          &:first-child {
            color: #000;
          }

          &:nth-child(2),
          &:last-child {
            text-align: left;
          }

          &:before {
            border-color: #d9d9d9;
          }
        }
      }

      .unorder-list {
        li {
          font-size: 12px;
          line-height: 18px;
          padding-left: 15px;
          margin-top: 4px;
          color: #666;

          &:first-child {
            font-size: 16px;
          }

          &:before {
            top: 8px;
            width: 3px;
            height: 3px;
            background: #171717;
          }
        }
      }
    }

    .btn-close {
      position: absolute;
      top: 40px;
      right: 40px;
    }
  }
`;

export const BoxCont = styled.div`
  background-color: #fff;
  min-height: ${mixin.pxToVw('150')};

  .title {
    text-align: center;
    line-height: ${mixin.pxToVw('50')};
    font-size: ${mixin.pxToVw('17')};
  }

  @media ${({ theme }) => theme.media.sm} {
    min-height: 320px;

    .title {
      line-height: 50px;
      font-size: 17px;
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    min-height: auto;
    padding-bottom: 60px;

    .title {
      text-align: left;
      font-size: 24px;
      line-height: 30px;
      padding-bottom: 30px;
      border-bottom: 2px solid #000;
    }
  }
`;

export const BoxBtn = styled.div`
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #eaeaea;
  ${mixin.flex({ direction: 'row', align: 'center', justify: 'center' })};

  .btn-bottom {
    width: 50%;
    font-size: ${mixin.pxToVw('16')};
    line-height: ${mixin.pxToVw('18')};
    height: ${mixin.pxToVw('50')};
    font-weight: 500;
    font-family: ${({ theme }) => theme.fontFamily.medium};
    &.st-close {
      color: #000;
    }
    &.st-confirm {
      color: #fff;
      background-color: #000;
    }
  }

  @media ${({ theme }) => theme.media.sm} {
    .btn-bottom {
      font-size: 16px;
      line-height: 18px;
      height: 50px;
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    padding-top: 30px;
    border-top: 1px solid #000;

    .btn-bottom {
      width: 140px;
      height: 40px;
      font-size: 14px;
      margin: 0px 7.5px;

      &.st-close {
        border: 1px solid #000;
      }
    }
  }
`;
